import React, { Fragment } from 'react';

import DataTableRelationDto from '../../classes/dtos/pathcommonmodule/DataTableRelationDto';

interface RelationSelectionProps {
    LinkedDataTables: DataTableRelationDto[];
}

const RelationSelection: React.FC<RelationSelectionProps> = ({ LinkedDataTables }) => {

    return (
        <Fragment>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 473 }}>
                <div style={{ width: 1, alignSelf: 'stretch', height: 'auto', transformOrigin: '0 0', border: '1px #3D3D46 dotted', marginBottom:46 }}></div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {LinkedDataTables.map((relation) => (
                        <div style={{ paddingTop: 24, paddingBottom: 0 }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <div style={{ width: 32, height: 1, transformOrigin: '0 0', border: '1px #3D3D46 dotted' }}></div>
                                <div style={{ width: 440, padding: '20px', background: '#1A1A20', borderRadius: 16, border: '1px #3D3D46 solid', justifyContent: 'flex-start', alignItems: 'center', gap: '32px', display: 'inline-flex', marginLeft: 0 }}>
                                    <div style={{ flexDirection: 'column', justifyContent: 'left', alignItems: 'left', gap: 12, display: 'inline-flex' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <div style={{ color: '#E3E3E8', fontSize: 16, fontFamily: 'Manrope', fontWeight: '600', lineHeight: '24px', letterSpacing: 0.32, wordWrap: 'break-word' }}>4. Choose your relation</div>
                                            {<img src="svgs/circle.svg" alt="circle" />}
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 16, color: '#9393A2', fontSize: 12, fontFamily: 'Manrope', fontWeight: '500', lineHeight: '15.60px', letterSpacing: 0.24, wordWrap: 'break-word', alignSelf: 'flex-start' }}>
                                            <span>{relation.SourceLabel + " selected"}</span>
                                            <span>{relation.TypeLabel}</span>
                                            <span>{relation.JoinTypeLabel}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Fragment >
    );
}

export default RelationSelection;